export const applySimilarLocales = (locale) => {
  const localeHash = {
    en: 'en-US',
    ja: 'ja-JP'
  }

  return localeHash[locale] || locale
}

const getNavigatorLanguageArray = () => (navigator.languages && navigator.languages[0])

export const getCurrentLocale = () => {
  const locale = getNavigatorLanguageArray() || navigator.language || navigator.userLanguage

  return applySimilarLocales(locale)
}
